import React, {useCallback} from 'react';
import {ReferralWithMyOrgOffers} from '../hook/useReferralQueryForProvider$';

import {ModalActionPayload} from '../modal/action';
import {ReferralModalContent} from './ReferralModalContent';


export function useReferralDetailModal(dispatch: React.Dispatch<ModalActionPayload>, onReferralInquiry?: (referralGuid: string) => void) {
    return useCallback(
        (referral: ReferralWithMyOrgOffers) => {
            dispatch({
                type: 'MODAL_ACTION',
                show: true,
                title: 'Referral Details',
                children: (<ReferralModalContent referral={referral} dispatch={dispatch} onReferralInquiry={onReferralInquiry}/>),
                referral,
            })
        },
        [dispatch, onReferralInquiry]
    );
}
